import { Subject } from "rxjs";

export class FileInput { 
    file: File; 
    src: string;
    progress: number;
    progressSubject: Subject<number>;
   }